import React, { useState, useEffect } from "react";
import {
    Badge,
    Button,
    Card,
    Col,
    Collapse,
    Form,
    message,
    Modal,
    Popconfirm,
    Row,
    Spin,
    Tabs,
    Table,
    Typography,
    Divider,
    Input,
    Select,
} from 'antd';
import { researchUI } from "../../api";
import { fieldRules } from "../ResearchUI/HardValues";
import { ReloadOutlined } from "@ant-design/icons";
import styles from "./AppAdmin.module.css";
import DomainAdmin from './components/DomainAdmin';
const { Text, Link } = Typography;
let USERNAME = null;
let ROLE = null;

let category = {};
let categoryName = {};
const ALLOWEDROLE = ['admin', 'research admin', 'reviewer'];
const AppAdmin = (props) => {
    USERNAME = props.user.email.split('@')[0];
    ROLE = props.user.role;
    const [loading, setLoading] = useState(false);
    const [initData, setInitData] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [refData, setRefData] = useState(false);

    const fetchAllInit = async () => {
        setLoading(true);
        const result = await researchUI({
            function: 'appAdmin',
            reqType: 'fetchAllPending',
        }).catch((err) => {
            message.error('Error while fetching Data');
        });
        setInitData(result.data);
        setLoading(false);
    };

    useEffect(() => {
        const getCategories = async () => {
            const result = await researchUI({
                function: 'getAllCategories',
            });
            setCategoryList(
                result.data.map((cat) => {
                    category[cat.category_id] = cat.category_name;
                    categoryName[cat.category_name + ''] = cat.category_id;
                    return { label: cat.category_name, value: cat.category_name };
                })
            );
        };
        getCategories();
    }, []);
    useEffect(() => {
        fetchAllInit();
    }, [refData]);

    return (
        <>
            {ALLOWEDROLE.includes(ROLE) ? (
                <>
                    {loading ? (
                        <Row justify="center" gutter={24}>
                            <Col span={1}>
                                <Spin tip="Loading..."></Spin>
                            </Col>
                        </Row>
                    ) : (
                        <Row gutter={[16, 16]} style={{ margin: '5px' }}>
                            <Col span={24}>
                                <Card bodyStyle={{ paddingTop: '5px' }}>
                                    <Tabs
                                        size={'small'}
                                        tabBarExtraContent={<ReloadOutlined onClick={fetchAllInit} />}
                                        defaultActiveKey={2}
                                    >
                                        <Tabs.TabPane tab={'Pending Requests'} key={1}>
                                            <SubReq
                                                initData={initData}
                                                categoryList={categoryList}
                                                refData={refData}
                                                setRefData={setRefData}
                                            />
                                        </Tabs.TabPane>
                                        <Tabs.TabPane tab={'Domain Request'} key={2}>
                                            <DomainAdmin user={USERNAME} />
                                        </Tabs.TabPane>
                                    </Tabs>
                                </Card>
                            </Col>
                        </Row>
                    )}
                </>
            ) : (
                <Row justify="center" gutter={24}>
                    <Col span={1}>
                        <Text>{"You don't have permission for this page."}</Text>
                    </Col>
                </Row>
            )}
        </>
    );
};

const SubReq = (props) => {
    const defaultModal = {
        visible: false,
        title: '',
        modalType: '',
    };
    let initData = props.initData;
    const [loading, setLoading] = useState(false);
    const [subReqEditTableData, setSubReqEditTableData] = useState([]);
    const [subReqAddTableData, setSubReqAddTableData] = useState([]);
    const [subReqCatTableData, setSubReqCatTableData] = useState([]);
    const [appExistTableData, setAppExistTableData] = useState([]);
    const [similarUrlTableData, setSimilarUrlTableData] = useState([]);
    const [modalPro, setModalPro] = useState(defaultModal);
    const [initValue, setInitValue] = useState({});
    const [editForm] = Form.useForm();

    const subReqEditTableCol = [
        {
            title: 'App ID',
            dataIndex: 'application_id',
            render: (text) => (
                <Link href={'/cciresearch/' + text} target={'_blank'}>
                    {text}
                </Link>
            ),
        },
        {
            title: 'App Name',
            dataIndex: 'req_appName',
        },
        {
            title: 'URL',
            dataIndex: 'req_url',
        },
        {
            title: 'Category',
            dataIndex: 'req_category',
        },
        {
            title: 'User',
            dataIndex: 'requestedBy',
        },
        {
            title: 'Action',
            dataIndex: 'id',
            render: (text) => <Link onClick={() => onClickVerify('EDIT', text)}>Process</Link>,
        },
    ];
    const subReqAddTableCol = [
        {
            title: 'App Name',
            dataIndex: 'req_appName',
        },
        {
            title: 'URL',
            dataIndex: 'req_url',
        },
        {
            title: 'Category',
            dataIndex: 'req_category',
        },
        {
            title: 'User',
            dataIndex: 'requestedBy',
        },
        {
            title: 'Action',
            dataIndex: 'id',
            render: (text) => <Link onClick={() => onClickVerify('ADD', text)}>Process</Link>,
        },
    ];

    const catSelProp = {
        showSearch: true,
        options: props.categoryList,
        optionFilterProp: 'label',
        filterOption: (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0,
        filterSort: (optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase()),
        style: { width: '300px' },
        size: 'small',
    };
    useEffect(() => {
        if (props?.initData?.pending) {
            setSubReqEditTableData(initData?.pending.filter((i) => i.req_type === 'EDIT' && !i.changeIn.includes('Category')));
            setSubReqAddTableData(initData?.pending.filter((i) => i.req_type === 'ADD'));
            setSubReqCatTableData(initData?.pending.filter((i) => i.req_type === 'EDIT' && i.changeIn.includes('Category')));
        }
    }, []);

    const similarApp = async (url, application_id) => {
        const result = await researchUI({
            function: 'checkSimilarAppUrl',
            application_id: application_id,
            req_url: url,
        })
            .then((result) => setSimilarUrlTableData(result.data.tableData))
            .catch((err) => message.error(err));
    };

    const onClickVerify = async (modalType, reqID) => {
        let reqData = initData?.pending.filter((i) => i.id === reqID)[0];
        let initVal = {
            id: reqData.id,
            application_id: reqData.application_id,
            edit_appName: reqData.req_appName,
            edit_url: reqData.req_url,
            edit_category: reqData.req_category,
            edit_comment: reqData.comments,
            changeIn: reqData?.changeIn?.split(','),
        };
        await setInitValue(initVal);
        similarApp(reqData.req_url, reqData.application_id);
        if (modalType === 'EDIT') {
            const getVerify = async () => {
                setLoading(true);
                const result = await researchUI({
                    function: 'getSubReqVerifyDetail',
                    application_id: reqData.application_id,
                    req_url: reqData.req_url,
                });
                if (result.success === 1) {
                    let customtag = result?.data?.details?.ResearchData?.customtag;
                    let priority = customtag?.includes('custom_p1') ? 'P1' : customtag?.includes('custom_p2') ? 'P2' : '';
                    initVal.application_name = result.data.details.application_name;
                    initVal.current_name = result.data.details.current_name;
                    initVal.url = result.data.details.AppUrl.url;
                    initVal.url_id = result.data.details.AppUrl.url_id;
                    initVal.category = category[result.data.details.ApplicationCategoryAssoc.category_id];
                    initVal.connector = result.data.details.connector_support;
                    initVal.priority = priority;
                    setInitValue(initVal);
                    setLoading(false);
                }
            };
            getVerify();

            setModalPro({
                visible: true,
                title: 'App Change Request',
                modalType: 'EDIT',
            });
        }
        if (modalType === 'ADD') {
            setModalPro({
                visible: true,
                title: 'New App Addition',
                modalType: 'ADD',
            });
        }
    };

    const onClickReject = () => {
        const rejectReq = async () => {
            const result = await researchUI({
                function: 'setSubReqStatus',
                id: initValue.id,
                user: USERNAME,
                comments: editForm.getFieldValue('edit_comment'),
                status: 'Reject',
            });
            if (result.success === 1) {
                message.success('Edit Submission Requst Rejected');
                setModalPro(defaultModal);
                props.setRefData(!props.refData);
            } else {
                message.error(result.msg);
            }
        };
        rejectReq();
    };

    const onEditFormFinish = (values) => {
        let changeIn = [];
        if (initValue.current_name != values.edit_appName) changeIn.push('AppName');
        if (initValue.url != values.edit_url) changeIn.push('URL');
        if (initValue.category != values.edit_category) changeIn.push('Category');
        let para = {
            function: 'setSubReqStatus',
            user: USERNAME,
            id: initValue.id,
            req_appName: values.edit_appName.trim(),
            req_url: values.edit_url,
            req_category: values.edit_category,
            category_id: categoryName[values.edit_category],
            req_type: modalPro.modalType,
            status: 'Submit',
            changeIn: changeIn.toString(),
            comments: editForm.getFieldValue('edit_comment'),
        };
        if (modalPro.modalType === 'EDIT') {
            para['application_id'] = initValue.application_id;
            para['application_name'] = initValue.application_name;
            para['url_id'] = initValue.url_id;
        }
        const submitReq = async () => {
            const result = await researchUI(para)
                .then((result) => {
                    if (result.success === 1) {
                        setAppExistTableData([]);
                        message.success('Request Successfully Accepted');
                        setModalPro(defaultModal);
                        props.setRefData(!props.refData);
                        return true;
                    } else {
                        setAppExistTableData(result.data.tableData);
                        message.error('Something went wrong');
                        return false;
                    }
                })
                .catch(() => {
                    message.error('Something went wrong.');
                    return false;
                });
        };
        submitReq();
    };

    const onEditFormChange = (changedValues, allValues) => {
        if (changedValues?.edit_url) {
            if (
                initValue.edit_url != editForm.getFieldValue('edit_url') &&
                changedValues.edit_url.includes('.') &&
                changedValues.edit_url.includes('http')
            ) {
                similarApp(changedValues.edit_url, initValue.application_id);
            }
        }
    };

    const resetForm = () => {
        editForm.resetFields();
    };

    const onModalClose = () => {
        setModalPro(defaultModal);
        props.setRefData(!props.refData);
    };
    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Collapse defaultActiveKey={['1']}>
                        <Collapse.Panel header={'App Changes Request'} key="1" showArrow={false}>
                            <Table
                                size={'small'}
                                bordered
                                dataSource={subReqEditTableData}
                                columns={subReqEditTableCol}
                                pagination={{
                                    pageSizeOptions: ['10', '20', '30', '50', '100'],
                                    defaultPageSize: ['10'],
                                    showSizeChanger: true,
                                }}
                            />
                        </Collapse.Panel>
                    </Collapse>
                </Col>
                <Col span={24}>
                    <Collapse defaultActiveKey={['1']}>
                        <Collapse.Panel header={'New App Addition'} key="1" showArrow={false}>
                            <Table
                                size={'small'}
                                bordered
                                dataSource={subReqAddTableData}
                                columns={subReqAddTableCol}
                                pagination={{
                                    pageSizeOptions: ['10', '20', '30', '50', '100'],
                                    defaultPageSize: ['10'],
                                    showSizeChanger: true,
                                }}
                            />
                        </Collapse.Panel>
                    </Collapse>
                </Col>
                <Col span={24}>
                    <Collapse defaultActiveKey={['1']}>
                        <Collapse.Panel header={'App Category Change Request'} key="1" showArrow={false}>
                            <Table
                                size={'small'}
                                bordered
                                dataSource={subReqCatTableData}
                                columns={subReqEditTableCol}
                                pagination={{
                                    pageSizeOptions: ['10', '20', '30', '50', '100'],
                                    defaultPageSize: ['10'],
                                    showSizeChanger: true,
                                }}
                            />
                        </Collapse.Panel>
                    </Collapse>
                </Col>
            </Row>
            <Modal
                title={modalPro.title}
                visible={modalPro.visible}
                onCancel={onModalClose}
                width={'80%'}
                destroyOnClose
                footer={[
                    <Popconfirm title="Are you sure want to 'Reject' request?" onConfirm={onClickReject}>
                        <Button type={'primary'} size={'small'} danger>
                            Reject
                        </Button>
                    </Popconfirm>,
                    <Button danger onClick={resetForm} size={'small'}>
                        Reset
                    </Button>,
                    <Popconfirm
                        title="Are you sure want to submit changes?"
                        onConfirm={() => {
                            editForm.submit();
                        }}
                    >
                        <Button type={'primary'} size={'small'}>
                            {modalPro.modalType === 'ADD' ? 'Add' : 'Update'}
                        </Button>
                    </Popconfirm>,
                ]}
            >
                {loading ? (
                    <Row justify="center" gutter={24}>
                        <Col span={1}>
                            <Spin tip="Loading..."></Spin>
                        </Col>
                    </Row>
                ) : (
                    <>
                        <Row>
                            <Col span={24}>
                                {appExistTableData.length > 0 ? (
                                    <Badge.Ribbon text="Exist" color="red">
                                        <Card title="Already Exist Apps" size="small">
                                            <Table
                                                bordered
                                                size={'small'}
                                                dataSource={appExistTableData}
                                                columns={[
                                                    {
                                                        title: 'App ID',
                                                        dataIndex: 'application_id',
                                                        render: (text) => (
                                                            <a target={'_blank'} href={'/cciresearch/' + text}>
                                                                {text}
                                                            </a>
                                                        ),
                                                    },
                                                    {
                                                        title: 'Ref Table',
                                                        dataIndex: 'table',
                                                    },
                                                    {
                                                        title: 'Data',
                                                        dataIndex: 'data',
                                                    },
                                                ]}
                                                scroll={{ y: 400 }}
                                                style={{ fontSize: '10px' }}
                                                pagination={false}
                                            ></Table>
                                        </Card>
                                    </Badge.Ribbon>
                                ) : (
                                    ''
                                )}
                            </Col>
                        </Row>
                        {modalPro.modalType === 'EDIT' ? (
                            <Row gutter={[16, 8]}>
                                <Col span={24}>
                                    <Divider orientation={'left'} className={styles.dividerSmall}>
                                        App Data
                                    </Divider>
                                </Col>
                                <Col>
                                    <Text>App Name: </Text>
                                    <Text type="secondary" copyable>
                                        {initValue.current_name}
                                    </Text>
                                </Col>
                                <Col>
                                    <Text>URL: </Text>
                                    <Text type="secondary" copyable>
                                        {initValue.url}
                                    </Text>
                                </Col>
                                <Col>
                                    <Text>Category: </Text>
                                    <Text type="secondary">{initValue.category}</Text>
                                </Col>
                                <Col>
                                    {initValue.priority === '' ? (
                                        ''
                                    ) : (
                                        <>
                                            <Text>Priority: </Text>
                                            <Text type="secondary">{initValue.priority}</Text>
                                        </>
                                    )}
                                </Col>
                                <Col>
                                    {initValue.connector === 'none' ? (
                                        ''
                                    ) : (
                                        <>
                                            <Text>Connector: </Text>
                                            <Text type="secondary">{initValue.connector}</Text>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        ) : (
                            ''
                        )}
                        <Form
                            form={editForm}
                            size={'small'}
                            initialValues={initValue}
                            onFinish={onEditFormFinish}
                            onValuesChange={onEditFormChange}
                        >
                            <Row gutter={[8, 0]}>
                                <Col span={8}>
                                    <Divider orientation={'left'} className={styles.dividerSmall}>
                                        App Name
                                    </Divider>
                                    <Form.Item name={'edit_appName'} rules={fieldRules.appName}>
                                        <Input
                                            size={'small'}
                                            style={{
                                                color: initValue?.changeIn?.includes('AppName') ? '#1890ff' : 'black',
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Divider orientation={'left'} className={styles.dividerSmall}>
                                        URL
                                    </Divider>
                                    <Form.Item name={'edit_url'} rules={fieldRules.url}>
                                        <Input
                                            size={'small'}
                                            style={{
                                                color: initValue?.changeIn?.includes('URL') ? '#1890ff' : 'black',
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Divider orientation={'left'} className={styles.dividerSmall}>
                                        Category
                                    </Divider>
                                    <Form.Item name={'edit_category'} rules={fieldRules.category}>
                                        <Select
                                            {...catSelProp}
                                            style={{
                                                color: initValue?.changeIn?.includes('Category') ? '#1890ff' : 'black',
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Divider orientation={'left'} className={styles.dividerSmall}>
                                        Comments (User & Admin)
                                    </Divider>
                                    <Form.Item name={'edit_comment'}>
                                        <Input.TextArea />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        <Row>
                            <Col span={24}>
                                {similarUrlTableData.length > 0 ? (
                                    <Badge.Ribbon text="Similar Url" color="red">
                                        <Card title="App with Similar Url" size="small">
                                            <Table
                                                bordered
                                                size={'small'}
                                                dataSource={similarUrlTableData}
                                                columns={[
                                                    {
                                                        title: 'App ID',
                                                        dataIndex: 'application_id',
                                                        render: (text) => (
                                                            <a target={'_blank'} href={'/cciresearch/' + text}>
                                                                {text}
                                                            </a>
                                                        ),
                                                    },
                                                    {
                                                        title: 'URL',
                                                        dataIndex: 'url',
                                                    },
                                                ]}
                                                scroll={{ y: 400 }}
                                                style={{ fontSize: '10px' }}
                                            ></Table>
                                        </Card>
                                    </Badge.Ribbon>
                                ) : (
                                    ''
                                )}
                            </Col>
                        </Row>
                    </>
                )}
            </Modal>
        </>
    );
};

export default AppAdmin;
